<template>
  <ul class="nav">
    <li class="nav-item">
      <a class="nav-link" href="#/" @click="$sidebar.displaySidebar(false)">
        <span class="d-lg-none">{{ $t("mobileMenu.home") }}</span>
      </a>
    </li>
    <li class="nav-item">
      <a
        class="nav-link"
        href="#/wheel-play"
        @click="$sidebar.displaySidebar(false)"
      >
        <span class="d-lg-none">{{ $t("mobileMenu.wheel") }}</span>
      </a>
    </li>
    <li class="nav-item">
      <a
        class="nav-link"
        href="#/lottery"
        @click="$sidebar.displaySidebar(false)"
      >
        <span class="no-icon">{{ $t("mobileMenu.lottery") }}</span>
      </a>
    </li>
    <li v-if="linguaPortuguesa" class="nav-item">
      <a
        class="nav-link"
        href="#/never-have"
        @click="$sidebar.displaySidebar(false)"
      >
        <span class="no-icon">{{ $t("mobileMenu.neverHave") }}</span>
      </a>
    </li>
    <li class="nav-item">
      <a
        class="nav-link"
        href="#/finger-selector"
        @click="$sidebar.displaySidebar(false)"
      >
        <span class="no-icon">{{ $t("mobileMenu.fingerSelector") }}</span>
      </a>
    </li>
    <li class="nav-item">
      <a
        class="nav-link"
        href="#/where-is-it"
        @click="$sidebar.displaySidebar(false)"
      >
        <span class="no-icon">{{ $t("mobileMenu.whereIsIt") }}</span>
      </a>
    </li>
    <li class="nav-item">
      <a
        class="nav-link"
        href="#/simon"
        @click="$sidebar.displaySidebar(false)"
      >
        <span class="no-icon">{{ $t("mobileMenu.simon") }}</span>
      </a>
    </li>
    <li v-if="!linguaPortuguesa" class="nav-item">
      <a
        class="nav-link"
        href="#/truth-or-drink"
        @click="$sidebar.displaySidebar(false)"
      >
        <span class="no-icon">{{ $t("mobileMenu.truthOrDrink") }}</span>
      </a>
    </li>
  </ul>
</template>
<script>
import { mixin } from "src/mixin";

export default {
  name: "mobile-menu",

  mixins: [mixin],

  methods: {
    changeRoute(route) {
      this.$sidebar.displaySidebar(false);
    },
  },
};
</script>
<style></style>
